import React, { useMemo, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    useTheme,
    Button,
} from '@mui/material';
import LogoTitle from '../components/LogoTitle';

import { checkInvitationCode } from '../services/apiService';
import AbstractBackground from '../components/AbstractBackground';
import StaticBackground from '../components/StaticBackground';
import LoadingSpinner from '../components/LoadingSpinner';
import PasswordReset from '../components/PasswordReset';
import InvitationCodeInput from '../components/InvitationCodeInput';
import FormContainer from '../components/FormContainer';

const Invitation = () => {
    const theme = useTheme();
    const [error, setError] = useState('');
    const [resetPassword, setResetPassword] = useState(false);
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const containerRef = useRef(null);

    const showLogin = () => navigate('/login');

    const handleSubmit = async (code) => {
        try {
            setLoading(true);
            await new Promise((resolve) => setTimeout(resolve, 2000));
            const result = await checkInvitationCode(code);
            setUserInfo(result);
            localStorage.setItem('tempToken', result.tempToken);
            setResetPassword(true);
            setLoading(false);
            setError('');
        } catch (error) {
            setLoading(false);
            setError('Invalid code');
        }
    };

    const memoizedBackground = useMemo(
        () => <AbstractBackground animate={loading} containerRef={containerRef} />, [loading]
    );
    const memoizedStaticBackground = useMemo(
        () => <StaticBackground numShapes={50} />, []
    );

    return (
        <Box
            ref={containerRef}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                //backgroundColor: theme.palette.background.default,
                position: 'relative',
                padding: 2,
            }}
        >
            {memoizedBackground}
            {memoizedStaticBackground}

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    alignItems: 'center',
                    m: 2,
                    p: 2,
                    borderRadius: 2,
                    boxShadow: 2,
                    animation: 'fadeIn 0.25s ease-in-out',
                    background: theme.palette.mode === 'dark'
                        ? 'linear-gradient(to top, rgba(33,33,33,0.9), rgba(25,118,210,0.3))'
                        : 'linear-gradient(to top, rgba(255,255,255,0.8), rgba(0,116,211,0.1))',
                    '@keyframes fadeIn': {
                        from: { opacity: 0 },
                        to: { opacity: 1 },
                    },
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: 2,
                        padding: 3,
                        maxWidth: 650,
                        minHeight: 400,
                        minWidth: 380,


                        background:
                            theme.palette.mode === 'dark'
                                ? 'linear-gradient(to top, rgba(33,33,33,0.8), rgba(0,116,211,0.2))'
                                : 'linear-gradient(to top, rgba(255,255,255,0.8), rgba(0,116,211,0.1))',
                        transition: 'background-color 0.3s ease',
                        //boxShadow: theme.shadows[3],

                    }}
                >
                    {loading ? (
                        <LoadingSpinner />
                    ) : resetPassword ? (
                        <Box sx={{ mt: 2, textAlign: 'center' }}>
                            <Button sx={logoStyle(theme)} fullWidth onClick={showLogin} disabled={loading}>
                                <LogoTitle />
                            </Button>
                            <FormContainer sx={{ mt: 2 }}>
                                <PasswordReset userInfo={userInfo} showLogin={showLogin} />
                            </FormContainer>
                        </Box>
                    ) : (
                        <Box sx={{ mt: 2, textAlign: 'center' }}>


                            <Button sx={logoStyle(theme)} fullWidth onClick={showLogin} disabled={loading}>
                                <LogoTitle />
                            </Button>

                            <FormContainer sx={{ mt: 2 }}>
                                <InvitationCodeInput
                                    onSubmit={handleSubmit}
                                    formError={error}
                                    showLogin={showLogin}
                                />
                            </FormContainer>
                        </Box>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

const logoStyle = (theme) => ({
    fontFamily: 'Arial, sans-serif',
    fontSize: 34,
    textTransform: 'none',
    fontWeight: 'bold',
    color: theme.palette.text.primary,
});

export default Invitation;
